/**
 * 首页
 */
import React, { Component } from "react";
import HeaderView from '../header/index';
import FooterView from '../footer/index';
import lang from '../lang/index';

class About extends Component {
    
    componentWillMount() {
        document.title = lang.template('页面标题');
    }

    componentDidMount(){
        let node = this.refs.doc;

        $(node).css({
            minHeight: document.documentElement.clientHeight
        });
    }

    onClick(channel) { 
        UP.Global.DA.add({
            eventName: 'Download',
            action: 'click',
            label: channel
        });
    }

    render() {
        return (
        	<div className="about">
        		<HeaderView selected="about"/>
                <div id="J-MainBody">
            		<div className="doc-wrap" ref="doc">
            			<div className="doc-container">
            				<div className="doc-content" data-show={UP.Global.version}>
    		        			<h2 className="title">{ lang.template('Up直播-直播全世界')}</h2>
    		        			<div className="subtitle">{ lang.template('让全世界看到你的美')}</div>
    		        			<div className="desc">
    		        				{ lang.template('关于我们内容')}
    		        			</div>
                                <div className="btns clearfix">
                                    <a className="btn ios" onClick={this.onClick.bind(this, 'IOS')} href="https://itunes.apple.com/cn/app/up直播-全球love/id1235469329?mt=8" target="_blank">
                                        <i></i><em>{lang.template('iOS下载')}</em>
                                    </a>
                                    <a className="btn android" onClick={this.onClick.bind(this, 'Android')} href="http://n.cdn.pengpengla.com/android/13797.apk" target="_blank">
                                        <i></i><em>{lang.template('Android下载')}</em>
                                    </a>
                                    <a className="btn google" onClick={this.onClick.bind(this, 'Google')} href="https://play.google.com/store/apps/details?id=com.asiainno.uplive" target="_blank">
                                        <i></i><em>{lang.template('Google Play')}</em>
                                    </a>
                                </div>
    	        			</div>
            			</div>
                    </div>
        		</div>
        	</div>
        )
    }
}

export default About;


// WEBPACK FOOTER //
// ./js/views/about.js